import React from 'react';
import { SvgProps, Svg } from '@utex/ui-kit';

export const IconSideIdeas = (props: SvgProps) => (
  <Svg {...props}>
    <path d="M12 1C7.581 1 4 4.564 4 8.962c0 4.423 3.556 6.192 5.333 9.73h5.334C16.444 15.154 20 13.385 20 8.962 20 4.564 16.419 1 12 1zm0 2.654v4.423h3.556L12 14.269V9.846H8.444L12 3.654zM9.333 20.462v.884c0 .978.796 1.77 1.778 1.77 0 .234.094.459.26.625a.891.891 0 0 0 1.518-.626c.982 0 1.778-.791 1.778-1.769v-.884H9.333z" />
  </Svg>
);

export const IconSidePortfolio = (props: SvgProps) => (
  <Svg {...props}>
    <path d="M11.2 3.2a1.6 1.6 0 0 0-1.6 1.6H4a1.6 1.6 0 0 0-1.6 1.6v6.4A1.6 1.6 0 0 0 4 14.4h16a1.6 1.6 0 0 0 1.6-1.6V6.4A1.6 1.6 0 0 0 20 4.8h-5.6a1.6 1.6 0 0 0-1.6-1.6h-1.6zm.8 8a.8.8 0 1 1 0 1.6.8.8 0 0 1 0-1.6zm-9.6 4.355V18.4A1.6 1.6 0 0 0 4 20h16a1.6 1.6 0 0 0 1.6-1.6v-2.845A3.167 3.167 0 0 1 20 16H4c-.585 0-1.127-.17-1.6-.445z" />
  </Svg>
);

export const IconSideFeed = (props: SvgProps) => (
  <Svg {...props}>
    <path d="M18.463 11.066c-.269-.35-.584-.655-.888-.958-.759-.701-1.635-1.203-2.37-1.94-1.706-1.704-2.08-4.52-.994-6.68-1.05.268-2.044.876-2.861 1.542-2.967 2.43-4.135 6.716-2.733 10.395a.985.985 0 0 1 .093.385c0 .257-.175.491-.409.585-.257.116-.537.046-.747-.14a.968.968 0 0 1-.175-.2c-1.285-1.67-1.496-4.064-.62-5.98-1.915 1.589-2.931 4.275-2.791 6.81.047.584.117 1.168.315 1.752.164.7.467 1.402.841 2.02 1.215 2.021 3.352 3.47 5.654 3.762 2.452.315 5.08-.14 6.96-1.87 2.103-1.938 2.863-5.022 1.753-7.708l-.152-.304a6.51 6.51 0 0 0-.911-1.46l.035-.011zm-3.62 7.358c-.328.28-.854.584-1.262.701-1.285.444-2.57-.187-3.364-.958 1.401-.327 2.22-1.355 2.453-2.394.198-.935-.164-1.706-.316-2.605-.14-.864-.116-1.6.234-2.406.175.444.409.888.677 1.238.888 1.168 2.278 1.682 2.57 3.27a1.8 1.8 0 0 1 .07.503c.035.957-.374 2.009-1.074 2.64l.011.011z" />
  </Svg>
);

export const IconSideBook = (props: SvgProps) => (
  <Svg {...props}>
    <path d="M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5-1.95 0-4.05.4-5.5 1.5v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z" />
    <path d="M17.5 10.5c.88 0 1.73.09 2.5.26V9.24c-.79-.15-1.64-.24-2.5-.24-1.7 0-3.24.29-4.5.83v1.66c1.13-.64 2.7-.99 4.5-.99zM13 12.49v1.66c1.13-.64 2.7-.99 4.5-.99.88 0 1.73.09 2.5.26V11.9c-.79-.15-1.64-.24-2.5-.24-1.7 0-3.24.3-4.5.83zm4.5 1.84c-1.7 0-3.24.29-4.5.83v1.66c1.13-.64 2.7-.99 4.5-.99.88 0 1.73.09 2.5.26v-1.52c-.79-.16-1.64-.24-2.5-.24z" />
  </Svg>
);

export const IconSideAccounts = (props: SvgProps) => (
  <Svg {...props}>
    <path d="M19 14V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zm-9-1c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm13-6v11c0 1.1-.9 2-2 2H4v-2h17V7h2z" />
  </Svg>
);

export const IconSidePassport = (props: SvgProps) => (
  <Svg {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.818 2h13.364c1 0 1.818.8 1.818 1.778v18.444C20 23.2 19.182 24 18.182 24H4.818C3.818 24 3 23.2 3 22.222V3.778C3 2.8 3.818 2 4.818 2zM15 20v-1H8v1h7zm-8-2v-2h9v2H7zm4.5-13a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7z"
    />
  </Svg>
);

export const IconSideUserpic = (props: SvgProps) => (
  <Svg viewBox="0 0 80 80" {...props}>
    <rect width="80" height="80" rx="40" fill="#3A3A3C" />
    <path
      d="M40.08 37.14c5.88 0 10.36-5.22 10.36-12.03 0-6.36-4.59-11.78-10.36-11.78-5.8 0-10.44 5.42-10.39 11.78 0 6.8 4.49 12.03 10.4 12.03zM21.75 62.22h36.5c2.5 0 3.97-.78 3.97-3.18 0-7.09-8.5-16.88-22.22-16.88-13.69 0-22.22 9.8-22.22 16.88 0 2.4 1.47 3.18 3.97 3.18z"
      fill="#fff"
    />
  </Svg>
);
